<template>
  <div class="nav-wrapper">
    <div class="container-fluid">
      <b-nav class="nav--root">
        <!--<b-nav-item :active="currentPage === 'dashboard'" to="/">Dashboard</b-nav-item>-->
        <b-nav-item :active="currentPage === 'customers'" to="customers"> Customers </b-nav-item>
        <b-nav-item :active="currentPage === 'jobs' && !isOctopos" to="jobs">Jobs</b-nav-item>
        <b-nav-item :active="currentPage === 'jobs-dresdengo'" to="jobs-dresdengo"
          >DresdenGO Jobs</b-nav-item
        >

        <b-nav-item :active="currentPage === 'promos'" to="promos">Promos & Campaigns</b-nav-item>
        <b-nav-item :active="currentPage === 'newsletter-users'" to="newsletter-users"
          >Newsletter Subscribers</b-nav-item
        >
        <b-nav-item :href="giftCardsUrl" target="_blank" rel="noopener noreferrer"
          >Gift Cards</b-nav-item
        >
        <b-nav-item :active="currentPage === 'settings'" to="settings"> Settings </b-nav-item>
      </b-nav>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const GIFT_CARDS_ORDERS_URL = 'https://gift-dashboard.dresden.io/orders';

// Regions that exist as companies in the Gift Card System. Anything else (a new
// region added in IO before it exists there) drops the hint and lets the
// dashboard fall back to its own default rather than deep-linking nowhere.
const GIFT_CARDS_REGIONS = ['AU', 'NZ', 'CA'];

export default {
  name: 'Nav',
  computed: {
    currentPage() {
      return this.$route.name;
    },
    ...mapGetters('auth', ['selectedOutlet', 'currentRegion']),
    // Deep link the Gift Card System into the region selected in IO (DP-4606).
    // `currentRegion` is undefined until regions load, hence the _.get default.
    giftCardsUrl() {
      const countryCode = this._.get(this.currentRegion, 'country_code', '').toUpperCase();
      if (!GIFT_CARDS_REGIONS.includes(countryCode)) {
        return GIFT_CARDS_ORDERS_URL;
      }
      return `${GIFT_CARDS_ORDERS_URL}?region=${countryCode}`;
    },
    isAU() {
      const regionId = this._.get(this.selectedOutlet, 'region_id', '');
      if (regionId === 6) {
        return true;
      }
      return false;
    },
  },
};
</script>
